import { render } from "./Recipient.vue?vue&type=template&id=c8f8eb12"
import script from "./Recipient.vue?vue&type=script&lang=js"
export * from "./Recipient.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__